import { render, staticRenderFns } from "./bidSubmit.vue?vue&type=template&id=4be4a2b0"
import script from "./bidSubmit.vue?vue&type=script&lang=js"
export * from "./bidSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports